import { convertGooglePlacesToAddressSchema } from '@frontend/api-client/utils';
import type { BaseApi } from '@frontend/api-client/utils/types';
import type {
  Address,
  AuthenticateImageKitResponse,
  AutocompleteAddressResponse,
  GooglePlacesDetailsResponse,
} from '@frontend/api-types';
import { convertArrayObjectKeysCase, convertObjectKeysCase } from '@frontend/duck-tape';
import { SYSTEM_ENDPOINTS } from './endpoints';

export const getSystemApi = (baseApi: BaseApi) =>
  baseApi.injectEndpoints({
    endpoints: (builder) => ({
      addressAutocomplete: builder.query<AutocompleteAddressResponse, string>({
        query: (input) => ({
          body: { input },
          method: 'POST',
          url: SYSTEM_ENDPOINTS.addressAutocomplete,
        }),
        transformResponse: (response: {
          suggestions: { placePrediction: { place_id: string; text: { text: string } } }[];
        }) => {
          const camelCaseObj = convertArrayObjectKeysCase(response.suggestions, 'camelCase') as {
            placePrediction: { placeId: string; text: { text: string } };
          }[];
          const transformed = camelCaseObj.map((p) => ({
            placeId: p.placePrediction.placeId,
            text: p.placePrediction.text.text,
          }));
          return transformed;
        },
      }),
      addressDetails: builder.query<Omit<Address, 'alias'>, string>({
        query: (placeId) => ({
          body: { placeId },
          method: 'POST',
          url: SYSTEM_ENDPOINTS.addressDetails,
        }),
        transformResponse: (response: GenericRecord) => {
          const camelCaseObj = convertObjectKeysCase(response, 'camelCase') as GooglePlacesDetailsResponse;
          return convertGooglePlacesToAddressSchema(camelCaseObj);
        },
      }),
      authenticateImageKit: builder.query<AuthenticateImageKitResponse, void>({
        query: () => ({
          method: 'GET',
          url: SYSTEM_ENDPOINTS.authenticateImageKit,
        }),
        transformResponse: (response: GenericRecord) =>
          convertObjectKeysCase(response, 'camelCase') as AuthenticateImageKitResponse,
      }),
    }),
    overrideExisting: false,
  });
